import { useContext } from "react";
import { LangContext, LangContextType } from "../utilities/customHooks";
import Button from "./Button";
import { useNavigate } from "react-router-dom";
import textData from "../textData.json";

const founderDashboards = textData.Pages.Dashboards.FounderDashboards as Record<string, Record<string, Record<string, string>>>;

function ProgramDetailsFooter({
  textPrefix,
  variant = "footer",
}: {
  textPrefix: string;
  /** "footer" = horizontal bottom strip (default); "sidebar" = stacked right-column card (IO/NF approved dashboard). */
  variant?: "footer" | "sidebar";
}) {
  const navigate = useNavigate();
  const { langState } = useContext(LangContext) as LangContextType;
  const source = founderDashboards[textPrefix];
  const sidebar = variant === "sidebar";

  return (
    <div className={sidebar ? "pdCont !flex-col !mb-0" : "pdCont"}>
      <div className={sidebar ? "flex-col gap-2 mr-10 mb-6" : "flex-col gap-2 mr-10"}>
        <h3 className={sidebar ? "mb-2" : ""}>{source.pdTitle[langState]}</h3>
        <p className="">{source.pdSub[langState]}</p>
      </div>
      <Button
        buttonText={source.pdButton[langState]}
        buttonType='secondary'
        actionHandler={() => navigate("/dashboard/program-details")}
      />
    </div>
  );
}

export default ProgramDetailsFooter;
